/**
 * Local chat cache storage.
 */
const STORAGE = window.localStorage
const pagniation = 'voicemailPagination'
const filters = 'voicemailFilters'
const activeWatchers = 'voicemailActiveWatchers'
const voicemailDismissTranscriptionDialog = 'voicemailDismissTranscriptionDialog'

export default {
  clear () {
    STORAGE.clear()
  },
  getDialogDismissedForever () {
    return STORAGE.getItem(voicemailDismissTranscriptionDialog) === 'true'
  },
  setDismissTranscriptionDialog (value) {
    STORAGE.setItem(voicemailDismissTranscriptionDialog, JSON.stringify(value))
  },
  getPagination () {
    const ls = STORAGE.getItem(pagniation)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },
  setPagination (data) {
    STORAGE.setItem(pagniation, JSON.stringify(data))
  },
  getFilters () {
    const ls = STORAGE.getItem(filters)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },
  setFilters (data) {
    STORAGE.setItem(filters, JSON.stringify(data))
  },
  getActiveWatchers () {
    const ls = STORAGE.getItem(activeWatchers)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },
  setActiveWatchers (watchers) {
    STORAGE.setItem(activeWatchers, JSON.stringify(watchers))
  }
}
